export async function deleteLsQuestions({ ids, themeName, token }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/deleteLsQuestions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ ids, themeName }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to delete questions");
  }

  return resp.json();
}
